// extracted by mini-css-extract-plugin
export default {"etQuickLaunch":"QuickLaunchButtons_etQuickLaunch__QU2qp"};